<script>
import CheckboxAnswer from "../framework/CheckboxAnswer";

import answerMixin from "@mixin/answer.mixin";

export default {
    name: "CheckboxAnswerComponent",
    mixins: [answerMixin],
    methods: {
        compare(instance) {
            return instance instanceof CheckboxAnswer;
        },
    },
};
</script>

<template>
    <v-checkbox v-if="state" v-model="value" v-bind="attrs" :persistent-hint="value" />
</template>

<style lang="scss" scoped></style>
